export default "__VITE_ASSET__dc5053a0__"